import { Container, Header, Title } from './styles'
import { HelpTable } from '../../components/feature/HelpPage'
import { useRecoilValue } from 'recoil'
import userAtom from '@/recoil/user'
import { validatePerm } from '@/libs/validatePermission'
import { BACKOFFICE_USER_PERMISSION } from '@/constant/BACKOFFICE_PERMISSION'
import UnauthorizedPage from '@/pages/Unauthorized'

function Help() {
  const user = useRecoilValue(userAtom)

  return (
    <>
      {validatePerm([BACKOFFICE_USER_PERMISSION.HEL010101], user.permissions) ? (
        <Container>
          <Header>
            <Title>ช่วยเหลือ</Title>
          </Header>
          <HelpTable />
        </Container>
      ) : (
        <UnauthorizedPage />
      )}
    </>
  )
}

export default Help
